import { useSettings } from "@/context/SettingsContext";
import { formatPrice } from "@/lib/api";
import { Zap } from "lucide-react";

export default function SaleBanner() {
  const { discountCents } = useSettings();
  if (!discountCents) return null;
  const amount = formatPrice(discountCents);
  return (
    <a
      href="/#shop"
      data-testid="sale-banner"
      className="block bg-primary text-black py-2.5 px-4 hover:bg-white transition-colors"
    >
      <div className="flex items-center justify-center gap-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-[0.22em]">
        <Zap className="w-3.5 h-3.5 shrink-0" fill="currentColor" />
        <span>{amount} off everything — limited time</span>
        <span className="hidden sm:inline underline underline-offset-4">Shop the drop</span>
      </div>
    </a>
  );
}
